import { CommunicationBaseFormType } from "@/components/organisms/Forms/Communication/formType";
import { defaultDateFormat } from "@/core/date";
import { phoneFormatter } from "@/core/phone";
import * as tagManager from "@/tagManager";

export enum RelationDetailsAreas {
    GENERAL_INFO = "generalInfo",
    IDENTITY_AND_DRIVER_LICENSE = "identityAndDriverLicense",
    CONTACT = "contact",
    PROFESSION = "profession",
    FINANCE = "finance",
}

interface FormDetails {
    id: tagManager.TMFormEditId;
    name: tagManager.TMFormEditName;
}

export const getFormDetailByArea = (detailArea: RelationDetailsAreas): FormDetails => {
    switch (detailArea) {
        case RelationDetailsAreas.CONTACT:
            return { id: "contact", name: "Contact" };
        case RelationDetailsAreas.FINANCE:
            return { id: "finance", name: "Finance" };
        case RelationDetailsAreas.GENERAL_INFO:
            return { id: "general_information", name: "General Information" };
        case RelationDetailsAreas.IDENTITY_AND_DRIVER_LICENSE:
            return { id: "driver_license_and_id", name: "Driver License and Id" };
        case RelationDetailsAreas.PROFESSION:
            return { id: "profession", name: "Profession" };

        default:
            return { id: null, name: null };
    }
};

interface PrintableDriverDetails {
    number: string;
    issueDate: string;
    type: string;
    issueCountry: string;
    nationalNumber: string;
    numberId: string;
    validTo: string;
    validFrom: string;
    issuedBy: string;
}

export const getDriverId = (details: MyBrokerApi.PersonalDetails): PrintableDriverDetails => ({
    number: details?.driversLicense?.number || "",
    issueDate: (details?.driversLicense?.issueDate && defaultDateFormat(details?.driversLicense?.issueDate)) || "",
    type: details?.driversLicense?.type?.id || "",
    issueCountry: details?.driversLicense?.issueCountry?.id || "",
    nationalNumber: details?.identityCard?.nationalNumber || "",
    numberId: details?.identityCard?.number || "",
    validTo: (details?.identityCard?.validTo && defaultDateFormat(details?.identityCard?.validTo)) || "",
    validFrom: (details?.identityCard?.validFrom && defaultDateFormat(details?.identityCard?.validFrom)) || "",
    issuedBy: details?.identityCard?.issuedBy || "",
});

interface PrintableFinanceDetails {
    type: string;
    number: string;
}

export const getFinance = (details: MyBrokerApi.PersonalDetails): PrintableFinanceDetails => ({
    type: details?.bankAccount?.type?.id || "",
    number: details?.bankAccount?.number || "",
});

export const getContact = (details: MyBrokerApi.PersonalDetails): CommunicationBaseFormType => ({
    phone0: phoneFormatter(details?.contact?.phone0),
    phone1: phoneFormatter(details?.contact?.phone1),
    phone2: phoneFormatter(details?.contact?.phone2),
    typePhone0: details?.contact.typePhone0?.id || "",
    typePhone1: details?.contact.typePhone1?.id || "",
    typePhone2: details?.contact.typePhone2?.id || "",
    email0: details?.contact.email0 || "",
    email1: details?.contact.email1 || "",
});

interface PrintableProfessionDetails {
    socialStatus: string;
    taxStatus: string;
    additionalTaxStatus: string;
    inamiNumber: string;
}

export const getProfession = (details: MyBrokerApi.PersonalDetails): PrintableProfessionDetails => ({
    socialStatus: details?.profession.socialStatus?.id || "",
    taxStatus: details?.profession.taxStatus?.id || "",
    additionalTaxStatus: details?.profession.additionalTaxStatus?.id || "",
    inamiNumber: details?.profession.inamiNumber || "",
});

interface PrintablePersonalDetails {
    personalTitle: string;
    lastName: string;
    firstName: string;
    gender: string;
    maritalStatus: string;
    birthdate: string;
    birthPlace: string;
    nationality: string;
    language: string;
}

export const getGeneralDetails = (details: MyBrokerApi.PersonalDetails): PrintablePersonalDetails => ({
    personalTitle: details?.personalTitle?.id || "",
    lastName: details?.lastName || "",
    firstName: details?.firstName || "",
    gender: details?.gender?.id || "",
    maritalStatus: details?.maritalStatus?.id || "",
    birthdate: (details?.birthdate && defaultDateFormat(details?.birthdate)) || "",
    birthPlace: details?.birthPlace || "",
    nationality: details?.nationality?.id || "",
    language: details?.language?.id || "",
});
